/* Phantom Foam — global behaviour. Dependency-free. */
(function () {
  function reveal() {
    var els = document.querySelectorAll('.pf-rise:not(.on)');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (e) { e.classList.add('on'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('on'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Accordions.

     A collapsed panel is genuinely closed, not merely short: it is marked
     inert and aria-hidden, and the stylesheet takes its visibility away once
     the height transition finishes. A screen reader never reads a collapsed
     answer and the Tab key never lands on a link inside one. */
  function closePanel(item) {
    item.classList.remove('open');
    var btn = item.querySelector('[data-pf-q]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    var panel = item.querySelector('[data-pf-a]');
    if (!panel) return;
    panel.style.maxHeight = null;
    panel.setAttribute('aria-hidden', 'true');
    if ('inert' in panel) { panel.inert = true; } else { panel.setAttribute('inert', ''); }
  }

  function openPanel(item) {
    item.classList.add('open');
    var btn = item.querySelector('[data-pf-q]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    var panel = item.querySelector('[data-pf-a]');
    if (!panel) return;
    panel.removeAttribute('aria-hidden');
    if ('inert' in panel) { panel.inert = false; } else { panel.removeAttribute('inert'); }
    panel.style.maxHeight = panel.scrollHeight + 40 + 'px';
  }

  function accordions() {
    document.querySelectorAll('[data-pf-acc]').forEach(function (root) {
      if (root.dataset.ready === '1') return;
      root.dataset.ready = '1';

      root.querySelectorAll('[data-pf-item]').forEach(function (item) {
        if (!item.classList.contains('open')) closePanel(item);
      });

      root.querySelectorAll('[data-pf-q]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('[data-pf-item]');
          var wasOpen = item.classList.contains('open');
          if (!root.hasAttribute('data-pf-multi')) {
            root.querySelectorAll('[data-pf-item]').forEach(closePanel);
          } else {
            closePanel(item);
          }
          if (!wasOpen) openPanel(item);
        });
      });

      root.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var item = e.target.closest('[data-pf-item]');
        if (!item || !item.classList.contains('open')) return;
        closePanel(item);
        var btn = item.querySelector('[data-pf-q]');
        if (btn) btn.focus();
      });
    });
  }

  /* An open panel is sized in pixels, so a resize that reflows its text would
     otherwise clip it. */
  function resizeOpenPanels() {
    document.querySelectorAll('[data-pf-item].open [data-pf-a]').forEach(function (panel) {
      panel.style.maxHeight = panel.scrollHeight + 40 + 'px';
    });
  }

  function forms() {
    document.querySelectorAll('form.pf-form').forEach(function (f) {
      if (f.dataset.ready === '1') return;
      f.dataset.ready = '1';
      f.addEventListener('submit', function () {
        if (!f.checkValidity()) {
          var bad = f.querySelector(':invalid');
          if (bad) bad.focus();
          return;
        }
        var b = f.querySelector('[type="submit"]');
        if (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; }
      });
    });
  }

  /* Tab strips used by the problem and building routers. */
  function tabs() {
    document.querySelectorAll('[data-pf-tabs]').forEach(function (root) {
      if (root.dataset.ready === '1') return;
      root.dataset.ready = '1';
      var btns = root.querySelectorAll('[data-pf-tab]');
      var panes = root.querySelectorAll('[data-pf-pane]');
      function show(i) {
        btns.forEach(function (b, n) {
          b.classList.toggle('on', n === i);
          b.setAttribute('aria-selected', n === i ? 'true' : 'false');
          b.tabIndex = n === i ? 0 : -1;
        });
        panes.forEach(function (p, n) { p.hidden = n !== i; });
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { show(i); });
        b.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = (i + 1) % btns.length;
          if (e.key === 'ArrowLeft') n = (i - 1 + btns.length) % btns.length;
          if (n !== null) { e.preventDefault(); btns[n].focus(); show(n); }
        });
      });
      show(0);
    });
  }

  /* Scroll-snap rails: dots, arrows, and keyboard. Progressive enhancement —
     the rail is a plain scrollable row without this. */
  function rails() {
    document.querySelectorAll('[data-pf-rail]').forEach(function (root) {
      if (root.dataset.ready === '1') return;
      root.dataset.ready = '1';
      var track = root.querySelector('[data-pf-track]');
      var slides = root.querySelectorAll('[data-pf-slide]');
      var dots = root.querySelector('[data-pf-dots]');
      var prev = root.querySelector('[data-pf-prev]');
      var next = root.querySelector('[data-pf-next]');
      if (!track || !slides.length) return;

      function step() {
        if (slides.length < 2) return track.clientWidth;
        return slides[1].offsetLeft - slides[0].offsetLeft;
      }
      function perView() {
        return Math.max(1, Math.round(track.clientWidth / step()));
      }
      function pages() {
        return Math.max(1, slides.length - perView() + 1);
      }
      function index() {
        return Math.round(track.scrollLeft / step());
      }

      function buildDots() {
        if (!dots) return;
        var n = pages();
        dots.innerHTML = '';
        if (n < 2) { root.querySelector('.pf-rail__ui').style.display = 'none'; return; }
        root.querySelector('.pf-rail__ui').style.display = '';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'pf-dot';
          b.setAttribute('aria-label', 'Go to item ' + (i + 1));
          (function (i) {
            b.addEventListener('click', function () {
              track.scrollTo({ left: i * step(), behavior: 'smooth' });
            });
          })(i);
          dots.appendChild(b);
        }
        sync();
      }
      function sync() {
        var i = Math.min(index(), pages() - 1);
        if (dots) {
          Array.prototype.forEach.call(dots.children, function (d, n) {
            d.classList.toggle('on', n === i);
            d.setAttribute('aria-current', n === i ? 'true' : 'false');
          });
        }
        if (prev) prev.disabled = track.scrollLeft < 4;
        if (next) next.disabled = track.scrollLeft > track.scrollWidth - track.clientWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () {
        window.clearTimeout(track._t);
        track._t = window.setTimeout(sync, 60);
      });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step(), behavior: 'smooth' }); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); }
      });
      window.addEventListener('resize', function () {
        window.clearTimeout(root._r);
        root._r = window.setTimeout(buildDots, 150);
      });
      buildDots();
    });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(resizeOpenPanels, 150);
  });

  function boot() { reveal(); accordions(); forms(); tabs(); rails(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
